import styled from 'styled-components'
import { colors } from 'client/styles'
import { ButtonBase } from 'src/comps/Button/styles'

export const MapBannerBase = styled.div`
  border-radius: 8px;
  border: 2px solid ${colors.grey4};
  cursor: pointer;
  display: flex;
  margin-block-end: 20px;
  position: relative;

  &:disabled {
    color: ${colors.white};
    cursor: not-allowed;

    img {
      filter: grayscale(1);
    }
  }

  &:active {
    opacity: 0.8;
  }

  img {
    border-radius: 5px;
  }

  button {
    inset-inline-start: 50%;
    position: absolute;
    inset-block-start: 50%;
    transform: translate(calc(var(--transform-direction) * -50%), -50%);
  }
`

export const ButtonViewMap = styled(ButtonBase)`
  align-items: center;
  background-color: ${colors.white};
  border-radius: 8px;
  border: 2px solid ${colors.grey1};
  display: flex;
  padding-block: 10px;
  padding-inline: 19px;

  p {
    color: ${colors.grey1};
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4;
    margin-inline-start: 4px;
  }

  svg {
    margin-inline-end: 5px;
  }
`
